import { type ReactNode } from "react";
import { RotateCcw, Search } from "lucide-react";
import { Button } from "./Button";
import { Input } from "./Input";

type ListToolbarProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
  resultCount: number;
  children?: ReactNode;
  onReset?: () => void;
  hasActiveFilters?: boolean;
};

/** Einheitliche Suche, Filterfläche, Trefferzahl und Rücksetzen für Arbeitslisten. */
export function ListToolbar({ searchValue, onSearchChange, searchPlaceholder, resultCount, children, onReset, hasActiveFilters = false }: ListToolbarProps) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
      <div className="relative min-w-52 flex-1 sm:max-w-sm">
        <Search aria-hidden="true" className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input aria-label="Liste durchsuchen" placeholder={searchPlaceholder} value={searchValue} onChange={(event) => onSearchChange(event.target.value)} className="pl-9" />
      </div>
      {children}
      <div className="ml-auto flex items-center gap-2 text-sm text-slate-500" aria-live="polite">
        <span>{resultCount} {resultCount === 1 ? "Treffer" : "Treffer"}</span>
        {hasActiveFilters && onReset && <Button type="button" variant="ghost" size="sm" onClick={onReset}><RotateCcw aria-hidden="true" className="h-4 w-4" />Zurücksetzen</Button>}
      </div>
    </div>
  );
}
